import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Modal, Spin } from 'antd';
import { BulbTwoTone, UnlockTwoTone, ImportOutlined, LoginOutlined, DoubleRightOutlined, QuestionCircleOutlined, UserAddOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import Layout, { Content, Footer, Header } from 'antd/lib/layout/layout'
import { _Button } from '../services/Forms/Forms';
import { globalText } from '../services/Text/GlobalText';
import { acakText } from '../services/Crypto';
// import _Api from '../services/Api/_ApiBase';
import { _Toastr } from '../services/Toastr/Notify/_Toastr';
import { LogOut } from '.';
// import _ApiBase from '../services/Api/_ApiBase';
import axios from 'axios';
import { baseURL_R } from '../services/BaseUrl';
import MainLayouts from '../layouts/MainLayouts';
import { Col, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

// import logo from "/assets/img/logo.png"

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function LoginMobile() {

    const query = useQuery();
    const [username, setUsername] = useState()
    const [password, setpassword] = useState()
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const history = useHistory()

    const goto = query.get('goto');


    useEffect(() => {
        setLoading(false)
        LogOut();

        const uName = query.get('username');
        const uPass = query.get('password');


        if (uName != null && uPass != null) {
            directLogin(uName, uPass);
        }

    }, [])


    const directLogin = (uN, uP) => {
        try {
            setLoading(true)
            // window.location.href = "/home";

            let obj = {
                username: uN,
                password: uP
            }
            axios.post(`${baseURL_R}/auth-do-login`, obj).then(res => {
                const data = res.data;
                if (data.sts == "1") {
                    let user = JSON.stringify(res.data);
                    sessionStorage.setItem(globalText.x_auth_resu, acakText(user))
                    sessionStorage.setItem(globalText.x_auth_user, acakText(res.data.user.role))
                    sessionStorage.setItem(globalText.x_auth_access_token, acakText(data.token))
                    sessionStorage.setItem(globalText.x_auth_refresh_token, acakText(data.refresh_token))
                    sessionStorage.setItem(globalText.authorization, acakText(data.role))
                    // sessionStorage.setItem('token', data.token)
                    window.location.href = goto;
                    // history.push(goto)
                    // histori.push("ShowDataPengadaan")
                } else {
                    _Toastr.error("Akses di tolak ...")
                    setLoading(false)
                    return
                }
                // setError(false)
            }).catch(err => {
                setLoading(false)
                _Toastr.error("Gagal terhubung ke server, Periksa jaringan anda ...")

            })
        } catch (error) {
            setLoading(false)
            _Toastr.error("Gagal terhubung ke server, Periksa jaringan anda ...")
        }
    }

    const queryString = window.location.search;  // Gets the query string part of the URL (e.g., "?name=JohnDoe&age=25")
    const urlParams = new URLSearchParams(queryString);


    return (
        <center>
            <Spin tip="" size="large">
                <div style={{
                    padding: "130px",
                    display: "flex",
                    justifyContent: "center", /* Horizontally center */
                    alignItems: "center",     /* Vertically center */
                    height: "100vh",

                }}>
                    <h1> Mohon Tunggu ... </h1>
                </div>
            </Spin>

        </center >

    )
}


export default LoginMobile
